import { Form, Input, Button } from 'antd'
import { formRules } from 'utils'
import { useAuthContext } from 'context/authContext'

export function useAuth() {
    const { isAuthenticated, authenticate, error, setIsAuthenticated } = useAuthContext()

    const renderAuthRequest = t => {
        const rules = formRules(t)

        return (
            <div className='login-wrap'>
                <h2>{t('admin_page.auth_title')}</h2>
                <p>{t('admin_page.auth_descr')}</p>
                <Form name='confirm-pwd' className='form-wrap' onFinish={authenticate}>
                    <Form.Item name='pwd' rules={[rules.required]}>
                        <Input.Password placeholder={t('general.password')} />
                    </Form.Item>
                    <div className='buttons'>
                        <Button type='primary' htmlType='submit'>
                            {t('general.actions.login')}
                        </Button>
                    </div>
                    {error ? <span className='error'>{t(error)}</span> : null}
                </Form>
            </div>
        )
    }

    return { isAuthenticated, renderAuthRequest, setIsAuthenticated }
}
